import {
    IonBackButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    isPlatform,
  } from "@ionic/react";
import { FileTypeCreateForm } from "./components/FileTypeCreateForm";
  
  export const FileTypeCreate = () => {
    return (
      <IonPage>
        <IonHeader class="ion-no-border">
          <IonToolbar>
            <IonButtons slot="start">
              <IonBackButton
                text={isPlatform("ios") ? "Tipos de archivos" : ""}
                defaultHref={`/app/tic/tipos-de-archivos/`}
                color="light"
              />
            </IonButtons>
            <IonTitle>Nuevo tipo de archivo</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <FileTypeCreateForm />
        </IonContent>
      </IonPage>
    );
  };
  